export default {
    switchCheckbox: {
        height: 0,
        width: 0,
        visibility: "hidden",
    },
    switchLabel: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        width: "46px",
        height: "28px",
        borderRadius: "30px",
        position: "relative",
        transition: "background .2s",
        background: "#ccc",
        border: "0.2px solid #C4C4C4",
        boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
        marginBottom: 0,
    },
    switchButton: {
        content: '',
        position: "absolute",
        top: "2px",
        left: "2px",
        width: "22px",
        height: "22px",
        borderRadius: "30px",
        transition: "0.2s",
        background: "#fff",
        boxShadow: "0 0 2px 0 rgba(10, 10, 10, 0.29)",
    },
    switchButtonActive: {
        left: "calc(100% - 2px)",
        transform: "translateX(-100%)",
    }
}